export default "__VITE_ASSET__A4f$Tql3__"